import { Component, OnDestroy } from '@angular/core';
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { Subscription } from 'rxjs';
import { MenuItem, MessageService } from 'primeng/api';

import { AlertService } from '@core/services/util/alert.service';
import { TokenService } from './security/services/token.service';
import { Router } from '@angular/router';
import { SessionUserService } from './security/services/session-user.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnDestroy {

    subscription: Subscription;

    items: MenuItem[];

    displayDialog = false;

    infoDialgo: any;

    environment = environment;

    topbarItemClick: boolean;

    topbarMenuActive: boolean;

    constructor(public app: AppComponent,
        public appMain: AppMainComponent,
        private messageService: MessageService,
        private alertService: AlertService,
        private tokenService: TokenService,
        private router: Router,
        private sessionUserService: SessionUserService
    ) { }

    get userName(): string {
        return this.sessionUserService.userSession.user_name;
    }
    onTopbarMenuButtonClick(event: Event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;

        event.preventDefault();
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    navegarUrl(envFront: string, param?: string): void {
        window.open(envFront + '/' + param + '?type=topbar&', '_self');
    }

    signOut() {
        this.tokenService.signOut();
        this.router.navigate(["security/login"])
    }

    changePassword() {
        this.router.navigate(["security/change-password"])
    }

    changeGame() {
        this.router.navigate(["game"])
    }

}
